export default __webpack_public_path__ + "static/media/video-preview.de38e831.png";